<template>
  <a-upload
    listType="picture-card"
    class="avatar-uploader"
    :accept="acceptType"
    :showUploadList="false"
    :action="actionUrl"
    :fileList="fileList"
    :beforeUpload="beforeUpload"
  >
    <div v-if="imgUrl" class="ie-align-middle">
      <a-icon class="delete-img" type="close" @click.stop="handleDeleteImage" />
      <img :src="imgUrl" alt="avatar" />
    </div>
    <div v-else>
      <a-icon :type="uploadLoading ? 'loading' : 'plus'" />
      <div class="ant-upload-text">上传图片</div>
    </div>
  </a-upload>
</template>
<script>
import UploadCore from './md5-core';
export default {
  name: 'UpfileImage',
  props: {
    // 是否是移动端
    isMobile: {
      type: Boolean,
      default: false
    },
    value: {
      default: ''
    },
    // 移动端单独传图片格式
    imageType: {
      type: String,
      default: ''
    },
    acceptType: {
      type: String,
      default: 'image/jpg, image/jpeg, image/png'
    },
    fileSizeInKB: {
      type: Number,
      default: 500
    },
    atLessInKB: {
      type: Number,
      default: 0
    },
    handleSuccess: {
      type: Function
    },
    handleDone: {
      type: Function
    },
    handleError: {
      type: Function
    },
    handleProgress: {
      type: Function
    },
    getAttachmentIdFlag: {
      type: Boolean,
      default: false
    },
    md5: {
      type: Boolean,
      default: true
    }
  },

  model: {
    prop: 'value',
    event: 'valueChange'
  },

  data() {
    return {
      actionUrl: '',
      uploadLoading: false,
      fileList: [],
      imgUrl: ''
    };
  },

  created() {
    this.imgUrl = this.value;
  },

  watch: {
    value(val) {
      this.imgUrl = val;
    }
  },

  methods: {
    beforeUpload(file, fileList) {
      console.log('选择的文件->', fileList);

      this.$emit('beforeUpload', file, fileList);
      const fileSize = file.size / 1024; // KB
      if (fileSize > this.fileSizeInKB) {
        let remindSize = this.fileSizeInKB / 1024;
        remindSize = Math.round(remindSize * 100) / 100;
        if (remindSize > 0.5) {
          remindSize = remindSize + 'MB';
        } else {
          remindSize = this.fileSizeInKB + 'KB';
        }
        this.$message.error('图片不能大于' + remindSize);
        return false;
      }

      if (this.atLessInKB && fileSize < this.atLessInKB) {
        let remindSize = this.atLessInKB / 1024;
        remindSize = Math.round(remindSize * 100) / 100;
        if (remindSize > 0.5) {
          remindSize = remindSize + 'MB';
        } else {
          remindSize = this.atLessInKB + 'KB';
        }
        this.$message.error('图片不能小于' + remindSize);
        return false;
      }

      // 移动端acceptType为image/* 使用imageType验证图片格式
      if (this.isMobile || this.imageType) {
        if (!file.type || this.imageType.indexOf(file.type) <= -1) {
          this.$message.error(
            '请上传 ' + this.imageType + ' 格式的图片文件！',
            10
          );
          return;
        }
      } else {
        if (this.acceptType.indexOf(file.type) <= -1) {
          this.$message.error(
            '请上传 ' + this.acceptType + ' 格式的图片文件！',
            10
          );
          return;
        }
      }

      this.imgUrl = '';
      // 每选择一个文件会触发一次该方法，所以通过判断fileList的更改来调用上传
      if (this.fileList !== fileList) {
        this.fileList = fileList;
        this.uploadLoading = true;
        this.handleUpload();
      }
      return false;
    },

    handleUpload() {
      const { fileList } = this;
      let upload = new UploadCore(this.getAttachmentIdFlag, this.md5);
      upload.uploadFileList(
        fileList,
        list => {
          this.uploadLoading = false;
          /* this.$emit('input', list[0].__remoteUrl);
          this.imgUrl = list[0].__remoteUrl; */
          console.log('所有文件上传结束！', Array.from(list));
          this.handleDone && this.handleDone(Array.from(list));
          // 删除已上传文件，防止重复上传
          this.fileList.length = 0;
        },
        async (err, file) => {
          // console.log('单文件上传结束！', err, file);
          if (err) {
            this.handleError && this.handleError(err, file);
            return this.$message.error('上传失败！' + err.message);
          } else {
            // 帮改bug，只在单文件上传成功时触发 fixed by ycx on 2019-5-22
            if (fileList.length === 1) {
              this.$emit('input', file.__remoteUrl);
              this.imgUrl = file.__remoteUrl;
              this.$emit('valueChange', this.imgUrl);
            }
            this.handleSuccess && this.handleSuccess([file]);
          }
        },
        (event, file) => {
          this.handleProgress && this.handleProgress(event, file);
          file.percent =
            Math.floor((event.loaded / event.total) * 100 * 100) / 100;
        }
      );
    },

    handleDeleteImage() {
      this.imgUrl = '';
      this.$emit('valueChange', this.imgUrl);
    }
  }
};
</script>

<style lang="stylus" scoped>
.avatar-uploader
  > .ant-upload
    width 128px
    height 128px
  .ie-align-middle
    position relative
    width 100%
    height 100%
  img
    position absolute
    left 50%
    top 50%
    transform translate(-50%, -50%)
    max-width 100%
    max-height 100%
  .delete-img
    font-size 12px
    position absolute
    right -15px
    top -15px
    width 20px
    height 20px
    border-radius 20px
    background red
    color #fff
    border 4px solid red
.ant-upload-select-picture-card i
  font-size 32px
  color #999
.ant-upload-select-picture-card .ant-upload-text
  margin-top 8px
  color #666
</style>
